import { Button, Card, Container } from 'react-bootstrap';
import DOMPurify from 'dompurify';
import { PublicationItem } from '../models/models';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { removeInlineStyles } from '../services/htmlUtils';

export const PublicationsSection = ({ data = undefined, handleOnClick }: { data: PublicationItem[] | undefined, handleOnClick: (publicationItem: PublicationItem) => void }) => {
  if (!data) return null;

  return (
    <section id="publications" className="bg-ternary pb-5">
      <Container className="my-5">
        <h2 className='mb-3'>Publications</h2>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={20}
          slidesPerView={1} 
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            1024: { slidesPerView: 2 }, 
          }}
          className="two-columns-swiper"
        >
          {data.map((publicationItem, index) => (
            <SwiperSlide key={index}>
              <Card className='shadow'>
                <div className="d-flex align-items-center">
                  {publicationItem.imageOriginal && (
                    <Card.Img 
                      variant="top" 
                      src={publicationItem.imageOriginal} 
                      alt={publicationItem.summary} 
                      className="object-fit-cover" 
                      style={{ width: '180px', height: 'auto' }}
                    />
                  )}
                  <Card.Body>
                    <Card.Title>{publicationItem.title}</Card.Title>
                    <Card.Text>
                      <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(removeInlineStyles(publicationItem.summary)) }} />
                      {publicationItem.attachments?.map((attachment: any, index: number) => (
                        <button key={index} className="btn btn-primary d-block mt-2" onClick={() => window.open(attachment.link, '_blank')}>
                          {attachment.name}
                        </button>
                      ))}
                    </Card.Text>
                   {publicationItem.text && (
                    <Button variant="primary" onClick={() => handleOnClick(publicationItem)}>
                      Read more
                    </Button>
                    )}
                  </Card.Body>
                </div>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};
